import { useEffect } from "react";
import { getToken, getTokenExpiry, isTokenExpired } from "../utils/persist";
import { handleTokenRefreshFailure, refreshToken } from "../components/auth/tokenRefreshService";

const REFRESH_BUFFER_MS = 60 * 1000;

const useTokenExpiryCheck = () => {
  const token = getToken();

  useEffect(() => {
    if (!token) return undefined;

    const expiryTime = getTokenExpiry(token) || 0;
    const delay = Math.max(0, expiryTime - Date.now() - REFRESH_BUFFER_MS);

    const checkAndRefreshToken = async () => {
      const currentToken = getToken();
      if (currentToken && isTokenExpired(currentToken)) {
        const newToken = await refreshToken();
        if (!newToken) {
          handleTokenRefreshFailure();
        }
      }
    };

    const timeoutId = setTimeout(checkAndRefreshToken, delay);
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkAndRefreshToken();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [token]);
};

export default useTokenExpiryCheck;
